<template>
  <ConfirmDialog></ConfirmDialog>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li><a class="text-500 no-underline line-height-3 cursor-pointer">PARAMETROS</a></li>
    <li class="px-2"><i class="pi pi-angle-right text-500 line-height-3"></i></li>
    <li><span class="text-900 line-height-3">VEHÍCULOS</span></li>
  </ul>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />

    <div class="flex align-items-start flex-column lg:justify-content-between lg:flex-row">
      <div class="font-medium text-3xl text-900">
        Administrar Vehículos
        <Badge size="xlarge" severity="success">{{ totalRecords }}</Badge>
      </div>
      <div class="flex mt-3 lg:mt-0 gap-2">
        <Button
          icon="pi pi-refresh"
          class="p-button-info p-button-outlined"
          v-tooltip.top="'Actualizar'"
          @click="cargarVehiculos"
        />
        <Button
          v-if="'Vehiculos Crear' in auth.user.permissions"
          label="NUEVO"
          icon="pi pi-plus"
          class="p-button-outlined p-button-lg"
          @click="openNuevo"
        />
      </div>
    </div>

    <div class="surface-100 p-2 border-round mt-3 mb-2 border-1 surface-border flex gap-2 align-items-end flex-wrap">
      <div class="flex-1" style="min-width: 220px">
        <strong>BUSCAR:</strong>
        <div class="p-input-icon-right w-full">
          <InputText
            v-model="filtros.buscar"
            class="w-full"
            placeholder="Placa, cliente, marca, color..."
            @keyup.enter="buscarVehiculos"
          />
          <i class="pi pi-search" @click="buscarVehiculos" style="cursor: pointer" />
        </div>
      </div>
      <div style="min-width: 160px">
        <strong>TAMAÑO:</strong>
        <Dropdown
          v-model="filtros.tamanio"
          :options="tamanios"
          optionLabel="label"
          optionValue="value"
          placeholder="Todos"
          showClear
          class="w-full"
          @change="buscarVehiculos"
        />
      </div>
      <div style="min-width: 160px">
        <strong>ESTADO:</strong>
        <Dropdown
          v-model="filtros.estado"
          :options="[{ label: 'TODOS', value: '' }, ...estados]"
          optionLabel="label"
          optionValue="value"
          class="w-full"
          @change="buscarVehiculos"
        />
      </div>
      <div>
        <Button
          icon="pi pi-search"
          label="BUSCAR"
          class="p-button-primary p-button-lg p-button-outlined"
          @click="buscarVehiculos"
        />
      </div>
    </div>

    <DataTable
      ref="dt_vehiculos"
      :value="vehiculos"
      :loading="cargando"
      dataKey="id"
      :lazy="true"
      :paginator="true"
      :rows="lazyParams.rows"
      :totalRecords="totalRecords"
      :rowHover="true"
      class="p-datatable-sm"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[15, 50, 100]"
      currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} Vehículos"
      responsiveLayout="scroll"
      showGridlines
      stripedRows
      @page="onPage"
      @row-dblclick="editVehiculo($event.data)"
    >
      <template #loading>
        <div class="flex align-items-center justify-content-center"><ProgressSpinner /></div>
      </template>
      <template #empty>
        <span class="flex align-items-center justify-content-center p-invalid">No existen Registros!</span>
      </template>

      <Column header="#">
        <template #body="slotProps">
          {{ (lazyParams.page - 1) * lazyParams.rows + slotProps.index + 1 }}
        </template>
      </Column>
      <Column field="nombre_cliente" header="CLIENTE"></Column>
      <Column field="tamanio" header="TAMAÑO">
        <template #body="{ data }">
          {{ tamanios.find((t) => t.value == data.tamanio)?.label ?? '-' }}
        </template>
      </Column>
      <Column field="placa" header="PLACA"></Column>
      <Column field="marca_texto" header="MARCA"></Column>
      <Column field="modelo_texto" header="MODELO"></Column>
      <Column field="color" header="COLOR"></Column>
      <Column header="ESTADO">
        <template #body="{ data }">
          <Tag :value="data.estado == 1 ? 'ACTIVO' : 'INACTIVO'" :severity="data.estado == 1 ? 'success' : 'danger'" />
        </template>
      </Column>
      <Column header="ACCIONES">
        <template #body="slotProps">
          <Button
            class="p-button-icon-only p-button-raised p-button-info"
            v-tooltip.top="'Ver Acciones'"
            icon="pi pi-ellipsis-v"
            @click="$refs['menu' + slotProps.data.id].toggle($event)"
          />
          <Menu :ref="'menu' + slotProps.data.id" :popup="true" :model="acciones(slotProps.data)" />
        </template>
      </Column>
    </DataTable>

    <VehiculoCreate
      :show="vehiculoDialog"
      :vehiculo="vehiculo"
      @closeModalVehiculo="ocultarDialog"
      @actualizarListadoVehiculo="cargarVehiculos"
    />
  </div>
</template>

<script>
import VehiculoService from '@/service/VehiculoService'
import { useAuth } from '@/stores'
import VehiculoCreate from '@/module/vehiculos/VehiculoCreate.vue'

export default {
  components: { VehiculoCreate },

  data() {
    return {
      vehiculos: [],
      totalRecords: 0,
      cargando: false,
      lazyParams: { page: 1, rows: 15 },
      filtros: {
        buscar: '',
        tamanio: null,
        estado: 1
      },
      vehiculoDialog: false,
      vehiculo: {},
      enviado: false,
      errors: {},
      estados: [
        { label: 'ACTIVO', value: 1 },
        { label: 'INACTIVO', value: 0 }
      ],
      tamanios: [
        { label: 'PEQUEÑO', value: 1 },
        { label: 'MEDIANO', value: 2 },
        { label: 'GRANDE', value: 3 },
        { label: 'OTRO', value: 4 }
      ]
    }
  },

  created() {
    this.auth = useAuth()
    this.vehiculoService = new VehiculoService()
  },

  mounted() {
    this.cargarVehiculos()
  },

  methods: {
    cargarVehiculos() {
      this.cargando = true
      const params = {
        page: this.lazyParams.page,
        per_page: this.lazyParams.rows,
        ...this.filtros
      }
      this.vehiculoService
        .getVehiculosPaginados(params)
        .then((response) => {
          this.vehiculos = response?.data ?? []
          this.totalRecords = response?.total ?? 0
        })
        .catch(() => {
          this.vehiculos = []
          this.totalRecords = 0
        })
        .finally(() => {
          this.cargando = false
        })
    },

    onPage(event) {
      this.lazyParams.page = event.page + 1
      this.lazyParams.rows = event.rows
      this.cargarVehiculos()
    },

    buscarVehiculos() {
      this.lazyParams.page = 1
      this.cargarVehiculos()
    },

    openNuevo() {
      this.vehiculo = { estado: { label: 'Activo', value: 1 } }
      this.enviado = false
      this.vehiculoDialog = true
    },

    ocultarDialog() {
      this.vehiculoDialog = false
      this.enviado = false
    },

    editVehiculo(vehiculo) {
      this.vehiculo = {
        ...vehiculo,
        estado: { label: vehiculo.estado == 1 ? 'ACTIVO' : 'INACTIVO', value: vehiculo.estado }
      }
      this.vehiculoDialog = true
      this.enviado = false
    },

    acciones(datos) {
      const perms = this.auth.user.permissions
      return [
        {
          label: 'Editar',
          icon: 'pi pi-pencil',
          disabled: !('Vehiculos Editar' in perms),
          command: () => this.editVehiculo(datos)
        },
        {
          label: 'Eliminar',
          icon: 'pi pi-trash',
          disabled: !('Vehiculos Eliminar' in perms),
          command: () => this.deleteVehiculo(datos.id)
        }
      ]
    },

    deleteVehiculo(id) {
      this.$confirm.require({
        message: '¿Está seguro que desea eliminar el vehículo?',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Si, deseo eliminar',
        rejectLabel: 'No, cancelar',
        accept: () => {
          this.vehiculoService.deleteVehiculo(id).then((response) => {
            this.$toast.add({
              severity: response.status == 200 ? 'success' : 'error',
              summary: response.status == 200 ? 'Éxito' : 'Error',
              detail: response.mensaje,
              life: 3000
            })
            if (response.status == 200) this.cargarVehiculos()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/demo/badges.scss';
.p-invalid {
  color: red;
}
</style>